/**
 * Current values for 'deviceType' are 'ios', 'android' and 'desktop'.
 * These match and must continue to match the possible values of
 * ticker device types.
 * @returns {'ios' | 'android' | 'desktop'}
 */
export const selectDeviceType = state => state.status.get('deviceType')

/** @returns {string} */
export const selectLocationPath = state => state.status.get('path')

/** @returns {200 | 404} */
export const selectLocationStatus = state => state.status.get('status')
